export default [
  {
    title: "一行一个",
    type: "oneLineOne",
    count: 1
  },
  {
    title: "一行二个",
    type: "oneLineTwo",
    count: 2
  },
  {
    title: "一行三个",
    type: "oneLineThree",
    count: 3
  },
  {
    title: "一行四个",
    type: "oneLineFour",
    count: 4
  },
  {
    title: "一左二右",
    type: "leftOneRightTwo",
    count: 3
  },
  {
    title: "二左一右",
    type: "leftTwoRightOne",
    count: 3
  },
  {
    title: "一左三右",
    type: "leftOneRightThree",
    count: 4
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Cube/typeOptions.js